import React, { useContext, useEffect, useState } from "react";
import { axiosUrl } from "../../api/axios";
import { UserContext } from "../../App";
import DepositComp from "../../components/Dashboard/DepositComp";
// import UploadScreenshot from "../../components/Dashboard/UploadScreenshot";
import DashboardLayout from "../../layouts/DashboardLayout";

const Deposit = (props) => {
  const [depositComp, setDepositComp] = useState(false);
  // const [screenshot, setScreenshot] = useState(false);
  const { userData } = useContext(UserContext);
  const [history, setHistory] = useState([]);
  useEffect(() => {
    // axios.get("/users/profile").then((response) => setUserData(response.data));

    axiosUrl.get("/transactions").then((response) => setHistory(response.data));
  }, []);

  // <script src="https://commerce.coinbase.com/v1/checkout.js?version=201807"></script>;
  return (
    <DashboardLayout>
      <div className="deposit">
        <h3 className="title-text sharp-text">Deposits</h3>
        <div className="top-nav">
          <button
            className="btn rounded"
            onClick={() => setDepositComp(!depositComp)}
          >
            <i className="fas fa-plus"></i>
            <p className="sharp-text">New Deposit</p>
          </button>

          <a
            href="https://www.binance.com/en-NG/buy-sell-crypto?channel=card&fiat=EUR"
            target="_blank"
            rel="noreferrer"
          >
            <button className="btn rounded">
              <i className="fas fa-shopping-cart"></i>
              <p className="sharp-text">Buy Crypto</p>
            </button>
          </a>

          {/* <a
            className="donate-with-crypto"
            href="https://commerce.coinbase.com/checkout/293f4eac-0a91-424c-b1d3-e282f72a5e54"
            target="_blank"
            rel="noreferrer"
          >
            <button className="btn rounded coinbase-btn">
              <img src="/imgs/coinbase-icon2.svg" alt="" />
              <p className="sharp-text">Deposit with Coinbase</p>
            </button>
          </a> */}
        </div>

        <div className={`make-deposit ${depositComp ? "show-deposit" : ""}`}>
          <DepositComp
            setDepositComp={setDepositComp}
            // setScreenshot={setScreenshot}
          />
        </div>

        {/* <div
          className={`upload-screenshot ${screenshot ? "show-screenshot" : ""}`}
        >
          <UploadScreenshot setScreenshot={setScreenshot} />
        </div> */}

        <h6 className="title-text mt-3 mx-3">Recent Deposits</h6>

        <div className="recent-deposits">
          <ul>
            <li className="list-title">
              <p className="sharp-text">Amount</p>
              <p className="sharp-text">Mode</p>
              <p className="sharp-text">Status</p>
              <p className="sharp-text">Date</p>
            </li>
            <hr />
            {history
              .filter(
                (history) =>
                  history.type === "Deposit" &&
                  history.userId === userData.user.id
              )
              .map((history) => {
                return (
                  <li key={history._id} className="recent-deposit">
                    <p className="sharp-text">{history.amount}</p>
                    <p className="sharp-text">{history.mode}</p>
                    <p
                      className="sharp-text"
                      style={{
                        color: history.status === true ? "green" : "red",
                      }}
                    >
                      {history.status === true ? "Completed" : "Pending"}
                    </p>
                    <p className="sharp-text">{history.date.slice(0, 10)}</p>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Deposit;
